import {
  ICheckout,
  ICheckoutCart
} from '@/interfaces/Checkout';
import { IRewardsSummary } from '@/interfaces/Rewards';

import { Cart } from './Cart';

export class Checkout implements ICheckout {
  cart: ICheckoutCart;

  constructor(checkout?: ICheckout, price?: { priceId: number, rewards: IRewardsSummary }) {
    this.cart = new Cart(checkout ? checkout.cart : null, price);
  }
}
